export class SettingsListLangForm {

    variables  = null;

    constructor(lang) {

        this.variables = {
            view: lang.general[3],
            modify: lang.general[2],
            reload: 'Reload',
            section: lang.settings[34],
            title: lang.settings[35],
            actions: lang.settings[32],
        }

    }

    lang() {
        return this.variables;
    }

}

export class SettingsEditLangForm {

    variables  = null;

    constructor(lang) {

        this.variables = {
            edit_doc: 'Edit Document',
            section: lang.settings[34],
            title: lang.settings[35],
            orient: lang.settings[37],
            horizontal: lang.settings[38],
            vertical: lang.settings[39],
            back_image: lang.settings[40],
            choose_file: 'Choose File',
            template: lang.settings[41],
            default_var: lang.settings[42],
            submit: lang.general[0],
            close: lang.general[17],
        }

    }

    lang() {
        return this.variables;
    }

}

export class SettingsSettingsLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            language: lang.settings[43],
            timezone: lang.settings[45],
            edit: 'Edit',
            update: 'Update',
        }

    }

    lang() {
        return this.variables;
    }

}